import { render, staticRenderFns } from "./logdetail.vue?vue&type=template&id=5505009f&scoped=true&"
import script from "./logdetail.vue?vue&type=script&lang=js&"
export * from "./logdetail.vue?vue&type=script&lang=js&"
import style0 from "./logdetail.vue?vue&type=style&index=0&id=5505009f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5505009f",
  null
  
)

export default component.exports